/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const CREATE_BULK_REQUEST_ANSWER = gql(`
  mutation CreateBulkRequestAnswer($inputs: [CreateRequestAnswerInput!]!) {
    createBulkRequestAnswer(inputs: $inputs) {
      id
      requestId
      questionId
      action {
        _
        ... on ReplaceStepAction {
          newSteps
        }
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          
          literalValue
          choices
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      createdAt
      createdBy
    }
  }
`);

export const CREATE_REQUEST_ANSWER = gql`
  mutation CreateRequestAnswer($input: CreateRequestAnswerInput!) {
    createRequestAnswer(input: $input) {
      id
      requestId
      questionId
      action {
        _
        ... on ReplaceStepAction {
          newSteps
        }
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
          choices
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      sourceLearning {
        id
        createdAt
        createdBy
        deletedAt
        deletedBy
        procedureId
        procedureName
        contextValue
        contextMetadata
      }
      createdAt
      createdBy
      summary
    }
  }
`;

export const UPDATE_LEARNED_ANSWER = gql`
  mutation UpdateLearnedAnswer($input: UpdateLearnedAnswerInput!) {
    updateLearnedAnswer(input: $input) {
      id
      questionFilter {
        stepPath
        questionType
        lexicalPath
      }
      stage
      action {
        _
        ... on ReplaceStepAction {
          newSteps
        }
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
          choices
        }
        ... on UseOauth2Action {
          accessToken
          refreshToken
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      originalAnswerId
      createdAt
      createdBy
      deletedAt
      deletedBy
      procedureId
      procedureName
      procedure {
        id
        name
        stage
      }
      contextValue
      contextMetadata
    }
  }
`;
